/**
 * Returns a string of random hex digits
 * @param length Length of the string to return
 */
export function randomHex(length: number): string {
    return [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
}
